import {inlineError} from '@s-ui/decorators'

import AdvertisingRepository from './AdvertisingRepository.js'

// This repository is only for client environments.
export default class DOMAdvertisingRepository extends AdvertisingRepository {
  constructor({config, fromAdvertisingVOToAdvertisingPageDataVOMapper, dispatcher}) {
    super()

    this._config = config
    this._advertising = this._config.get('advertising')
    this._segmentationEventName = this._advertising.SEGMENTATION_CHANGED_EVENT_NAME
    this._dispatcher = dispatcher
    this._fromAdvertisingVOToAdvertisingPageDataVOMapper = fromAdvertisingVOToAdvertisingPageDataVOMapper
  }

  @inlineError
  displayAds(advertisingVO) {
    const advertisingPageDataVO = this._fromAdvertisingVOToAdvertisingPageDataVOMapper
      .setUrl({url: window.location.pathname})
      .map(advertisingVO)

    window.OpenAdsQueue = window.OpenAdsQueue || []
    window.OpenAdsQueue.push(() =>
      this._dispatcher({
        eventName: this._segmentationEventName,
        detail: advertisingPageDataVO.toJSON()
      })
    )
  }
}
